
import { Box, Button, Card, CardContent, Container, Dialog, DialogContent, DialogTitle, Divider, FormControl, FormHelperText, Grid, IconButton, InputLabel, MenuItem, Select, TableCell, TableRow, TextField, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { toast } from 'react-toastify';

import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { authKey, CREATE_HIT_MANUAL_PO, GET_OTHER_PLANNING_NUMBER, GET_PLANNING_NUMBER_LIST, GET_PO_PREVIEW, GET_SPOT_BIDDING_REQ_LIST, GET_SPOT_BIDDING_REQ_LIST_FOR_ORDERS, GET_STOCK_TRANSFER_LIST, UPLOAD_DCUMENT } from '../../../common/URLs';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { Badge } from "react-bootstrap";
import { FileUploadMUI } from '../../../common/fileUpload/fileUploadMUI';
import { PreviewIcon, SubmitIcon } from '../../../common/icons';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import moment from 'moment';
import { useNavigate } from "react-router-dom";
import apiClient from '../../../axios';

export default function SpotBiddingPoCreation() {
    const navigate = useNavigate();
    const [stockListData, setStockListData] = useState();
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [planningNumber, setPlanningNumber] = useState();
    const [otherPlanningNumber, setOtherPlanningNumber] = useState();
    const [planningNumberList, setPlanningNumberList] = useState();
    const [documentsArray, setDocumentsArray] = useState([]);
    const [description, setDescription] = useState('');
    const [selectedFile, setSelectedFile] = useState();
    const [open, setOpen] = React.useState(false);
    const date = new Date();
    const [previewDetails, setPreviewDetails] = useState();
    const [uploadDocResponse, setUploadDocResponse] = useState();
    const [createPoResponse, setCreatePoResponse] = useState();
    const [isApiCalled, setIsApiCalled] = useState(false);


    const [confirmOpen2, setConfirmOpen2] = useState(false);
    const handleConfirmOpen2 = () => setConfirmOpen2(true);
    const handleConfirmClose2 = () => setConfirmOpen2(false);

    const [errorMessage, setErrorMessage] = useState({
        "DescriptionError": "",
        "planningNumberError": "",
        "isOtherPlanningNumber": "",
    });

    useEffect(() => {
        getSpotBiddingRequestList();
    }, []);

    const getSpotBiddingRequestList = (e) => {
        loaderService.showLoader();
        apiClient
            .post(GET_SPOT_BIDDING_REQ_LIST_FOR_ORDERS,
                {
                    "allotmentRequestNumber": "",
                    "isOrderGenerated": false
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setStockListData(response.data.spotBiddingAllotmentRequestDetailsList);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getPlanningNumberList = (financialYear, month) => {
        loaderService.showLoader();
        apiClient.post(GET_PLANNING_NUMBER_LIST,
            {
                "financialYear": financialYear,
                "month": month
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setPlanningNumberList(response.data.planningNumberList);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getOtherPlanningNumber = () => {
        loaderService.showLoader();
        apiClient.post(GET_OTHER_PLANNING_NUMBER,
            {
                "financialYear": selectedRowData?.financialYear,
                "month": selectedRowData?.month
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setOtherPlanningNumber(response.data.otherPlanningNumber);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const columns = [
        { field: "allotmentRequestNumber", headerName: 'Request Number', width: 180 },
        { field: 'financialYear', headerName: 'Financial Year', width: 120 },
        { field: 'month', headerName: 'Month', width: 100 },
        {
            field: 'materialType', headerName: 'Material Type', width: 150,
            valueGetter: (params) => {
                if (params.row.materialType === "RawBamboo" || params.row.materialType === "rawbamboo") {
                    return "Raw Bamboo"
                } else if (params.row.materialType === "ChipBamboo" || params.row.materialType === "chipbamboo") {
                    return "Chip Bamboo"
                }
                else return ""

            }
        },
        { field: 'allotmentQuantity', headerName: 'Quantity(MT)', width: 100 },
        { field: 'firstPartyType', headerName: "Source Type", width: 150 },
        { field: 'firstPartyUrn', headerName: "Source URN", width: 150 },
        { field: 'firstPartyName', headerName: "Source Name", width: 200 },
        { field: 'firstPartyLocationAddress', headerName: 'Source Address', width: 250 },
        { field: 'secondPartyType', headerName: "Destination Type", width: 150 },
        { field: 'secondPartyUrn', headerName: "Destination URN", width: 150 },
        { field: 'secondPartyName', headerName: "Destination Name", width: 200 },
        { field: 'secondPartyLocationAddress', headerName: 'Destination Address', width: 250 },
    ];


    const handleSelectionModelChange = (newSelection) => {
        setSelectedRows(newSelection);
        const selectedId = newSelection[0];
        const selected = stockListData.find((row) => row.id === selectedId);
        setSelectedRowData(selected || null);
    };

    useEffect(() => {
        if (selectedRowData) {
            getPlanningNumberList(selectedRowData?.financialYear, selectedRowData?.month);
            setDocumentsArray([{
                documentBlobName: selectedRowData?.biddingTermsFileId ? selectedRowData?.biddingTermsFileId : '',
                documentContainerName: selectedRowData?.biddingTermsFileId ? "pit" : "",
                documentName: selectedRowData?.biddingTermsFileName ? selectedRowData?.biddingTermsFileName : "",
                documentType: selectedRowData?.biddingTermsFileName ? "poSupportingDoc" : "",
                isActive: selectedRowData?.biddingTermsFileName ? 1 : '',
            }])
        } else setDocumentsArray([])
    }, [selectedRowData]);

    const onPlanningNumberChange = (e) => {
        setPlanningNumber(e.target.value);
        setErrorMessage({ ...errorMessage, planningNumberError: "" });
        if (e.target.value === "Other") {
            getOtherPlanningNumber()
        }
    }

    const onUploadCallBack = (docArray) => {
        setDocumentsArray(docArray);
    }

    const handleChange = (e) => {
        setDescription(e.target.value);
        if (e.target.name === "poDescription") {
            setErrorMessage({ ...errorMessage, poDescriptionError: "" });
        }
        if (e.target.name === "serviceStakeholderType") {
            setErrorMessage({ ...errorMessage, serviceStakeholderTypeError: "" });
        }
    };

    const payloadWithNewline = description?.replace(/\n/g, "<br />");

    const handleClose = () => {
        setOpen(false);
    };

    const getPoPreview = () => {
        if (selectedRows?.length === 0) {
            toast.error("Please Select Bidding Allotment Request")
        }
        else {
            loaderService.showLoader();
            apiClient
                .post(
                    GET_PO_PREVIEW,
                    {
                        "poDescription": payloadWithNewline,
                        "poMaterialType": selectedRowData?.materialType,
                        "poType": "SO",
                        "poStakeholderType": "Transporter",
                        "poStakeholderUrn": selectedRowData?.stakeholderUrn,
                        "poQuantity": selectedRowData?.allotmentQuantity,
                        "destinationStakeholderType": selectedRowData?.secondPartyType,
                        "destinationStakeholderUrn": selectedRowData?.secondPartyUrn,
                        "sourceStakeholderType": selectedRowData?.firstPartyType,
                        "sourceStakeholderUrn": selectedRowData?.firstPartyUrn,
                        "financialYear": selectedRowData?.financialYear,
                        "month": selectedRowData?.month,
                        "planningNumber": planningNumber === "Other" ? otherPlanningNumber : planningNumber,
                        "poUnitOfMeasure": "MT",
                        "distanceTravelled": selectedRowData?.distanceTravelled

                    },
                    {
                        headers: {
                            Authorization: "Bearer " + getLocalStorageItem('id_token'),
                        },
                    }
                )
                .then((response) => {
                    if (response.data) {
                        if (response.data.isSuccess) {
                            setOpen(true);
                            setPreviewDetails(response.data.poDetails);
                        }
                        else toast.error(response.data.message)
                    }
                    else toast.error("Error! Please try again!")
                    loaderService.hideLoader();
                })
                .catch(function (error) {
                    console.log("apiClientERROR", error);
                    loaderService.hideLoader();
                    toast.error(error.message);
                });

        }
    };

    // const onSubmit = (e) => {
    //     onHitSubmitButtonClick();
    // }

    const onSubmit = (e) => {
        if (selectedRows?.length === 0) {
            toast.error("Please Select Stock Transfer Request")
        }
        else handleConfirmOpen2();
    }

    // const onConfirmSubmit = (e) => {
    //     handleConfirmClose2();
    //     onPOCreationSubmit(e);
    // }

    
 
    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await onPOCreationSubmit();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setConfirmOpen2(false);
            setIsApiCalled(false);
        }
    };

    const onPOCreationSubmit = (e) => {
        createManualPO();
    }

    const createManualPO = () => {
        loaderService.showLoader();
        apiClient
            .post(
                CREATE_HIT_MANUAL_PO,
                {
                    "financialYear": selectedRowData?.financialYear,
                    "month": selectedRowData?.month,
                    "planningNumber": planningNumber === "Other" ? otherPlanningNumber : planningNumber,
                    "isOtherPlanningNumber": planningNumber === "Other" ? true : false,
                    "poStakeholderType": "Transporter",
                    "poStakeholderUrn": selectedRowData?.stakeholderUrn,
                    "destinationStakeholderType": selectedRowData?.secondPartyType,
                    "destinationStakeholderUrn": selectedRowData?.secondPartyUrn,
                    "sourceStakeholderType": selectedRowData?.firstPartyType,
                    "sourceStakeholderUrn": selectedRowData?.firstPartyUrn,
                    "poDescription": payloadWithNewline,
                    "poMaterialType": selectedRowData?.materialType,
                    "poType": "SO",
                    "poQuantity": selectedRowData?.allotmentQuantity,
                    "supportingDocumentId": documentsArray?.find((item) => item.documentType === "poSupportingDoc")?.documentBlobName,
                    "supportingDocumentName": documentsArray?.find((item) => item.documentType === "poSupportingDoc")?.documentName,
                    "containerName": "pit",
                    "distanceTravelled": selectedRowData?.distanceTravelled,
                    // "isStockTransferOrder": true,
                    // "stockTransferRequestId": selectedRowData?.id,
                    "isSpotBiddingOrder": true,
                    "allotmentRequestNumber": selectedRowData?.allotmentRequestNumber,
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                }
            )
            .then((response) => {
                setCreatePoResponse(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log("apiClientERROR", error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    useEffect(() => {
        if (createPoResponse) {
            if (createPoResponse.isSuccess === true) {
                toast.success(createPoResponse?.message)
                navigate('/soList')
            }
            else {
                toast.error(createPoResponse?.message ? createPoResponse?.message : "Error")
            }
        }
    }, [createPoResponse]);


    useEffect(() => {
        if (selectedFile) {
            getUploadFileDetails();
        }
    }, [selectedFile]);

    function getUploadFileDetails() {
        loaderService.showLoader();
        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("fileName", selectedFile.name);
        formData.append("containerName", "pit");
        apiClient
            .post(UPLOAD_DCUMENT, formData, {
                headers: {
                    AuthKey: authKey,
                },
            })
            .then((response) => {
                setUploadDocResponse(response.data);
                loaderService.hideLoader();
            })

            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    return (
        <>
            <Card>
                <CardContent>
                    <Grid container spacing={1} direction="row">
                        <Box style={{ height: 400, width: '100%' }}>
                            {
                                stockListData &&
                                <DataGrid
                                    getRowHeight={() => 'auto'}
                                    rows={stockListData}
                                    columns={columns}
                                    pageSize={10}
                                    components={{ Toolbar: QuickSearchToolbar }}
                                    checkboxSelection
                                    selectionModel={selectedRows}
                                    onSelectionModelChange={handleSelectionModelChange}
                                    isRowSelectable={(params) => {
                                        return selectedRows.length === 0 || selectedRows.includes(params.id);
                                    }}
                                />
                            }
                        </Box>
                        <Divider sx={{
                            width: '100%',
                            bgcolor: 'black',
                            marginTop: '3vh'
                        }} mt={2} />
                        <Grid item xs={12} mt={2}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} lg={4}>
                                    <TextField fullWidth label="Financial Year" size="small" value={selectedRowData?.financialYear || ''} disabled />
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <TextField fullWidth label="Month" size="small" value={selectedRowData?.month || ''} disabled />
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <TextField fullWidth label="Stakeholder Type" size="small" value={'Transporter'} disabled />
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <FormControl fullWidth size="small" required error={errorMessage.planningNumberError}>
                                        <InputLabel>Planning Number</InputLabel>
                                        <Select label="Planning Number" name="planningNumber" value={planningNumber || ''} onChange={(e) => onPlanningNumberChange(e)}>
                                            <MenuItem><em>Planning Number</em></MenuItem>
                                            {planningNumberList &&
                                                planningNumberList.map((items) => (
                                                    <MenuItem value={items}>{items}</MenuItem>

                                                ))}
                                            <MenuItem value="Other">Other</MenuItem>
                                        </Select>
                                        <FormHelperText sx={{ color: 'red' }}>{errorMessage.planningNumberError}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                {
                                    planningNumber === 'Other' &&
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            type="text"
                                            name="otherPlanningNumber"
                                            label="Other Planning Number"
                                            value={otherPlanningNumber || ''}
                                            disabled
                                        />
                                    </Grid>
                                }
                                <Grid item xs={12} lg={4}>
                                    <TextField fullWidth label="PO Type" size="small" value="SO" disabled />
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <TextField fullWidth label="Material Type" size="small" value={selectedRowData?.materialType || ''} disabled />
                                </Grid>
                                <Grid item xs={12} mt={2}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} lg={6}>
                                            <TextField fullWidth
                                                autoComplete="off"
                                                id="outlined-multiline-static"
                                                type="text"
                                                name="poDescription"
                                                label="Terms & Conditions"
                                                value={description || ''}
                                                multiline
                                                rows={4}
                                                onChange={(e) => handleChange(e)}
                                            />
                                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <Badge>{description?.length}</Badge>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <FileUploadMUI key="poSupportingDoc"
                                                // documentList={[{
                                                //     // documentType: "poSupportingDoc",
                                                //     documentName: selectedRowData?.supportingDocumentFileName,
                                                //     documentBlobName: selectedRowData?.supportingDocumentFileId,
                                                //     documentContainerName: "pit",
                                                //     isActive : 1
                                                // }]}
                                                documentList={documentsArray}
                                                documentType="poSupportingDoc"
                                                callBackDocumentUpload={onUploadCallBack}
                                                title="Upload Supporting Document"
                                                containerName="pit"
                                                errorMessage={errorMessage}
                                                setErrorMessage={setErrorMessage}
                                                documentError="fileError"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider sx={{
                                    width: '105%',
                                    bgcolor: 'black',
                                    marginTop: '3vh'
                                }} mt={2} />
                                <Grid item xs={12} lg={12}>
                                    <Typography variant="subtitle1">SO Creation for Bidding Allotment Request</Typography>
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <TextField fullWidth label="Transporter URN" size="small" value={selectedRowData?.stakeholderUrn || ''} disabled />
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <TextField fullWidth label="Quantity" size="small" value={selectedRowData?.allotmentQuantity || ''} disabled />
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <TextField fullWidth label="Source Stakeholder Type" size="small" value={selectedRowData?.firstPartyType || ''} disabled />
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <TextField fullWidth label="Source Stakeholder URN" size="small" value={selectedRowData?.firstPartyUrn || ''} disabled />
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <TextField fullWidth label="Destination Stakeholder Type" size="small" value={selectedRowData?.secondPartyType || ''} disabled />
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <TextField fullWidth label="Destination Stakeholder URN" size="small" value={selectedRowData?.secondPartyUrn || ''} disabled />
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <TextField fullWidth label="Distance Travelled" size="small" value={selectedRowData?.distanceTravelled || ''} disabled />
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            <Dialog maxWidth="xxl"
                open={open}
                onClose={handleClose}>
                <DialogTitle>PO Preview</DialogTitle>
                <DialogContent>
                    <Container >
                        <div class="logo-container"><img src="https://abrplscmsandbox.blob.core.windows.net/imageslatest/abepl-logo.png"
                            alt="Company Logo" width="150" /></div>
                        <div class="organization-details"> <strong>Assam Bio Ethanol Private Limited</strong><br /> (A JOINT VENTURE
                            ENTERPRISE)<br /> POST BOX NO. 003, N.R.COMPLEX<br /> DISTRICT : GOLAGHAT(ASSAM)<br /> PIN : 785699 </div>
                        {/* <div class="box-container1"> */}
                        <div class="boxPrint1"> <strong>CIN:</strong> U74999AS2018PTC018547<br /> <strong>PAN: </strong>
                            AAQCA9789H<br /> <strong>TAN:</strong> SHLA04440C <br /> <strong>GSTN:</strong> 18AAQCA9789H1ZP <br />
                        </div>
                        <div class="boxPrint">
                            <div class="headerPrint">Purchase Order</div>
                            <table>
                                <tr>
                                    <td>
                                        <p class="sub-heading">PO Number : {previewDetails?.poNumber}<strong></strong></p>
                                    </td>
                                    {/* <td>
                                                        <p class="sub-heading2"><strong></strong></p>
                                                    </td> */}
                                </tr>
                            </table>
                            Date : <strong>{moment(date).format('DD/MM/YYYY')}</strong>
                        </div>
                        {/* </div> */}
                        {/* <div class="box-container2"> */}
                        <div>
                            <h6 style={{ marginTop: "10px" }}><b>Vendor Details:</b></h6>
                            <p class="sub-heading">Name: {previewDetails?.poStakeholderName}</p>
                            <p class="sub-heading">URN: {previewDetails?.poStakeholderUrn}</p>
                            <p class="sub-heading">Contact Person: {previewDetails?.poContactPerson}</p>
                            <p class="sub-heading">Contact Number: {previewDetails?.poStakeholderContactNo}</p>
                            <p class="sub-heading">Address: {previewDetails?.poStakeholderAddress}</p>
                        </div>
                        <div >
                            <h6 style={{ marginTop: "15px" }}><b>Bill To:</b></h6>
                            <p class="sub-heading">Name: {previewDetails?.customerName}</p>
                            <p class="sub-heading">Address: {previewDetails?.customerAddress}</p>
                            <p class="sub-heading">Contact Number: {previewDetails?.customerPhonNumber}</p>
                        </div>
                        <div >
                            <h6 style={{ marginTop: "15px" }}><b>Ship To:</b></h6>
                            <p class="sub-heading">Name: {previewDetails?.destinationStakeholderName}</p>
                            <p class="sub-heading">Address: {previewDetails?.destinationStakeholderAddress}</p>
                            <p class="sub-heading">Contact Number: {previewDetails?.destinationStakeholderPhonNumber}</p>
                        </div>

                        {/* </div> */}
                        <div class="body-section">
                            <table class="table-bordered" style={{ marginTop: "20px" }}>
                                <thead>
                                    <tr>
                                        <th class="table-header">Item Code</th>
                                        <th class="table-header">Item Desc</th>
                                        <th class="table-header">Quantity (MT)</th>
                                        <th class="table-header">Distance Travelled (KM)</th>
                                        <th class="table-header">Price (INR)</th>
                                        <th class="table-header">Total (Exc. Taxes) (INR)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="table-row">{previewDetails?.itemCode}</td>
                                        <td class="table-row">{previewDetails?.poMaterialType}</td>
                                        <td class="table-row">{previewDetails?.poQuantity}</td>
                                        <td class="table-row">{selectedRowData?.distanceTravelled}</td>
                                        <td class="table-row">{previewDetails?.poUnitPrice}</td>
                                        <td class="table-row">{previewDetails?.poAmount}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <hr />
                        <table class="table-bordered" style={{ marginTop: "5px" }}>
                            <thead>
                                <tr>
                                    <th class="table-header">Total CGST</th>
                                    <th class="table-header">Total SGST</th>
                                    <th class="table-header">Total IGST</th>
                                    <th class="table-header">Total Tax</th>
                                    <th class="table-header">Total (Inc. Taxes) (INR)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="table-row">{previewDetails?.totalCGST}</td>
                                    <td class="table-row">{previewDetails?.totalSGST}</td>
                                    <td class="table-row">{previewDetails?.totalIGST}</td>
                                    <td class="table-row">{previewDetails?.totalTax}</td>
                                    <td class="table-row">{previewDetails?.totalAmount}</td>
                                </tr>
                            </tbody>
                        </table>
                        <hr />
                        <table>
                            <tr>
                                <td style={{ width: "20%" }}>Amount in words:</td>
                                <td style={{ width: "75%" }}>{previewDetails?.amountWords}</td>
                            </tr>
                        </table>
                        <hr />
                        <h5 style={{ marginTop: "20px" }}><b>For Assam Bio Ethanol Private Limited</b></h5>
                        <div class="box-container1" style={{ marginTop: "100px" }}>
                            <div class='boxPrint'>
                                <p class="sub-heading">Head Purchase</p>
                            </div>
                            <div class='boxPrint2'>
                                <p class="sub-heading2">Chief Executive Officer</p>
                            </div>
                        </div>
                        {/* <div style={{ height: "25px" }}></div> */}
                        <div class="terms">
                            <h5><b>Terms & Conditions:</b></h5>
                            <p style={{ whiteSpace: 'pre-wrap' }}>
                                {description}
                            </p>

                        </div>
                        <div class="footer"> Registered Office: Assam Bio Ethanol Private Limited, G.S. Road, Christanbasti,<br />
                            Guwahati- 781005 <br /> Website: www.abepl.co.in;<br /> Corporate Identification Number :
                            U74999AS2018PTC018547 </div>
                    </Container>

                </DialogContent>

            </Dialog>
            <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" color="primary" onClick={() => getPoPreview()} startIcon={<PreviewIcon />}>Preview</Button>
                <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => onSubmit(e)} endIcon={<SubmitIcon />}>Submit</Button>
            </Box>
            <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmSubmit} onClose={handleConfirmClose2} action="Submit" />

        </>
    );
}